import { PublicKey } from '@solana/web3.js'

export const PRESALE_TOKEN_PROGRAM = new PublicKey(
  '2wmKXX1xsxLfrvjEPrt2UHiqj8Gbzwxvffr9qmNjsw8g'
)

//EfQyMcrnjSyfESrcDkXXs4WZkaYmu3avt8LivMkXdqFY
